// Auto-generated translation data (clBatch5) — Formularios de conversión (LC-03..06).
// Pure data only: no i18n imports. Keys 1:1 es/en; namespace por defecto 'common'.
// pt usa fallback a es (los batches solo aportan es/en, como clBatch1-4).

export const es = {
  bookVisit: {
    title: 'Reservar cita',
    close: 'Cerrar',
    propertyLabel: 'Propiedad:',
    successMessage: '¡Visita reservada! Te confirmaremos en breve.',
    step0: '1. Elige un horario',
    loadingSlots: 'Cargando horarios…',
    noSlots: 'No hay horarios disponibles esta semana.',
    step1: '2. Tus datos',
    namePlaceholder: 'Nombre completo',
    phonePlaceholder: 'Teléfono (+34...)',
    emailPlaceholder: 'Email',
    contactHint: 'Teléfono o email (al menos uno).',
    submitting: 'Reservando…',
    submit: 'Confirmar reserva',
    errorLoadSlots: 'No se pudieron cargar los horarios disponibles.',
    errorRequiredFields: 'Completa todos los campos y elige un horario.',
    errorGeneric: 'Error al agendar.',
    errorSlotTaken: 'Ese horario ya está reservado. Elige otro.',
  },
  ownerLead: {
    operationOption0: 'Vender',
    operationOption1: 'Alquilar',
    operationOption2: 'Alquiler temporal',
    propertyTypeOption0: 'Piso / Apartamento',
    propertyTypeOption1: 'Casa / Chalet',
    propertyTypeOption2: 'Oficina',
    propertyTypeOption3: 'Local comercial',
    propertyTypeOption4: 'Terreno',
    propertyTypeOption5: 'Nave / Bodega',
    validationNamePhoneEmail: 'Indica tu nombre y al menos un teléfono o email.',
    errorInvalidData: 'Revisa los datos del formulario.',
    errorSubmit: 'No se pudo enviar. Inténtalo más tarde.',
    successTitle: '¡Recibimos tu solicitud!',
    successMessage: 'Un asesor te contactará en breve para concretar los siguientes pasos.',
    sendAnother: 'Enviar otra solicitud',
    formTitle: 'Cuéntanos sobre tu inmueble',
    formSubtitle: 'Te enviaremos una valoración orientativa y agendaremos una visita comercial.',
    operationLegend: '¿Qué quieres hacer?',
    propertyTypeLabel: 'Tipo de inmueble',
    bedroomsLabel: 'Habitaciones (opcional)',
    addressLabel: 'Dirección o ubicación',
    addressPlaceholder: 'Ej. Calle del Carmen, Pamplona',
    zoneLabel: 'Zona / barrio',
    zonePlaceholder: 'Iturrama, Rochapea…',
    areaLabel: 'Superficie (m²)',
    expectedPriceLabel: 'Precio esperado (€)',
    expectedRentLabel: 'Renta mensual esperada (€)',
    optionalSuffix: '— opcional',
    nameLabel: 'Nombre completo',
    phoneLabel: 'Teléfono',
    phonePlaceholder: '+34 …',
    emailLabel: 'Email',
    contactHint: 'Indica al menos uno: teléfono o email.',
    messageLabel: 'Mensaje (opcional)',
    messagePlaceholder: 'Cuéntanos cualquier detalle importante sobre tu inmueble…',
    appraisalTextBefore: 'Quiero recibir una ',
    appraisalHighlight: 'valoración gratuita',
    appraisalTextAfter: ' de mi inmueble.',
    submitting: 'Enviando…',
    submit: 'Enviar solicitud',
  },
  appraisal: {
    form: {
      title: 'Tasación gratuita',
      subtitle: 'Te damos una horquilla inmediata para tu inmueble basada en datos de mercado.',
      submit: 'Ver tasación gratuita',
      submitting: 'Calculando…',
      disclaimer: 'La estimación es orientativa. Para una valoración oficial firmada, podemos tramitar una tasación con un perito sin compromiso.',
    },
    fields: {
      operation: 'Operación',
      propertyType: 'Tipo de inmueble',
      address: 'Dirección (opcional)',
      city: 'Ciudad',
      postalCode: 'Código postal (opcional)',
      area: 'Superficie (m²) *',
      bedrooms: 'Habitaciones',
      bathrooms: 'Baños',
      yearBuilt: 'Año de construcción',
      condition: 'Estado',
      name: 'Nombre *',
      email: 'Email',
      phone: 'Teléfono',
    },
    placeholders: {
      address: 'C/ Mayor, 12',
      city: 'Pamplona',
      postalCode: '31001',
    },
    operations: ['Venta', 'Alquiler', 'Alquiler temporal'],
    propertyTypes: ['Piso / Apartamento', 'Casa / Chalet', 'Oficina', 'Local comercial', 'Terreno', 'Nave / Bodega'],
    conditions: ['A estrenar / Obra nueva', 'Buen estado', 'Para reformas parciales', 'A reformar'],
    errors: {
      area: 'Indica la superficie en m².',
      name: 'Indica tu nombre.',
      contact: 'Necesitamos email o teléfono para enviarte el resultado.',
      invalidData: 'Revisa los datos del inmueble (superficie y ubicación).',
      generic: 'No se pudo calcular ahora. Inténtalo en un momento.',
    },
    result: {
      opSale: 'venta',
      opRent: 'alquiler mensual',
      opRentTemp: 'alquiler temporal',
      title: 'Tu estimación de {{operation}}',
      subtitle: 'Horquilla orientativa basada en datos de mercado.',
      perM2: '{{price}} por m²',
      perM2Month: '{{price}} por m² al mes',
      noData: 'No tenemos suficientes datos para una estimación automática. Un asesor te contactará con una valoración más precisa.',
      officialTitle: '¿Quieres una tasación oficial firmada?',
      officialText: 'Un asesor te llamará para tramitar una tasación con un perito (sin compromiso).',
      recalculate: 'Calcular otra tasación',
    },
  },
  mortgage: {
    title: 'Simulador de hipoteca',
    intro: 'Una estimación orientativa para que sepas si esta vivienda encaja en tu presupuesto. Tipo de interés editable; consulta con tu banco antes de cerrar números.',
    priceLabel: 'Precio del inmueble',
    downPaymentLabel: 'Entrada / ahorro inicial',
    downPaymentPercent: '{{percent}}% del precio',
    termLabel: 'Plazo (años)',
    yearsValue: '{{years}} años',
    annualRateLabel: 'Tipo de interés anual (%)',
    monthlyPayment: 'Cuota mensual',
    totalPaid: 'Total a pagar',
    totalInterest: 'Intereses totales',
    ctaWant: 'Quiero esta hipoteca',
    successMessage: '¡Listo! Recibimos tu solicitud. Un agente te contactará en breve.',
    contactTitle: 'Datos de contacto',
    contactIntro: 'Te llamamos para asesorarte con la hipoteca para {{propertyTitle}}.',
    namePlaceholder: 'Nombre completo',
    phonePlaceholder: 'Teléfono (+34 …)',
    emailPlaceholder: 'Email',
    contactHint: 'Indica al menos uno: teléfono o email.',
    messagePlaceholder: 'Mensaje (opcional)',
    back: 'Volver',
    submitting: 'Enviando…',
    submit: 'Enviar solicitud',
    errorNameRequired: 'Indica tu nombre y al menos un teléfono o email.',
    error400: 'Revisa los datos: hace falta nombre y teléfono o email.',
    errorGeneric: 'No se pudo enviar la solicitud. Inténtalo más tarde.',
  },
};

export const en = {
  bookVisit: {
    title: 'Book a visit',
    close: 'Close',
    propertyLabel: 'Property:',
    successMessage: 'Visit booked! We\'ll confirm shortly.',
    step0: '1. Choose a time',
    loadingSlots: 'Loading available times…',
    noSlots: 'No available times this week.',
    step1: '2. Your details',
    namePlaceholder: 'Full name',
    phonePlaceholder: 'Phone (+34...)',
    emailPlaceholder: 'Email',
    contactHint: 'Phone or email (at least one).',
    submitting: 'Booking…',
    submit: 'Confirm booking',
    errorLoadSlots: 'Available times could not be loaded.',
    errorRequiredFields: 'Fill in all fields and pick a time.',
    errorGeneric: 'Booking failed.',
    errorSlotTaken: 'That time is already booked. Choose another.',
  },
  ownerLead: {
    operationOption0: 'Sell',
    operationOption1: 'Rent',
    operationOption2: 'Short-term rental',
    propertyTypeOption0: 'Flat / Apartment',
    propertyTypeOption1: 'House / Villa',
    propertyTypeOption2: 'Office',
    propertyTypeOption3: 'Commercial premises',
    propertyTypeOption4: 'Land',
    propertyTypeOption5: 'Warehouse',
    validationNamePhoneEmail: 'Enter your name and at least a phone number or email.',
    errorInvalidData: 'Please check the form details.',
    errorSubmit: 'Could not send. Please try again later.',
    successTitle: 'We received your request!',
    successMessage: 'An advisor will contact you shortly to arrange the next steps.',
    sendAnother: 'Send another request',
    formTitle: 'Tell us about your property',
    formSubtitle: 'We\'ll send you an indicative valuation and schedule a commercial visit.',
    operationLegend: 'What would you like to do?',
    propertyTypeLabel: 'Property type',
    bedroomsLabel: 'Bedrooms (optional)',
    addressLabel: 'Address or location',
    addressPlaceholder: 'E.g. Calle del Carmen, Pamplona',
    zoneLabel: 'Area / neighborhood',
    zonePlaceholder: 'Iturrama, Rochapea…',
    areaLabel: 'Surface area (m²)',
    expectedPriceLabel: 'Expected price (€)',
    expectedRentLabel: 'Expected monthly rent (€)',
    optionalSuffix: '— optional',
    nameLabel: 'Full name',
    phoneLabel: 'Phone',
    phonePlaceholder: '+34 …',
    emailLabel: 'Email',
    contactHint: 'Provide at least one: phone or email.',
    messageLabel: 'Message (optional)',
    messagePlaceholder: 'Tell us any important details about your property…',
    appraisalTextBefore: 'I want to receive a ',
    appraisalHighlight: 'free valuation',
    appraisalTextAfter: ' of my property.',
    submitting: 'Sending…',
    submit: 'Send request',
  },
  appraisal: {
    form: {
      title: 'Free appraisal',
      subtitle: 'We give you an instant price range for your property based on market data.',
      submit: 'See free appraisal',
      submitting: 'Calculating…',
      disclaimer: 'This estimate is indicative. For an official signed valuation, we can arrange an appraisal with a certified surveyor at no obligation.',
    },
    fields: {
      operation: 'Operation',
      propertyType: 'Property type',
      address: 'Address (optional)',
      city: 'City',
      postalCode: 'Postal code (optional)',
      area: 'Area (m²) *',
      bedrooms: 'Bedrooms',
      bathrooms: 'Bathrooms',
      yearBuilt: 'Year built',
      condition: 'Condition',
      name: 'Name *',
      email: 'Email',
      phone: 'Phone',
    },
    placeholders: {
      address: '123 Main St',
      city: 'Pamplona',
      postalCode: '31001',
    },
    operations: ['Sale', 'Rent', 'Short-term rent'],
    propertyTypes: ['Flat / Apartment', 'House / Villa', 'Office', 'Commercial premises', 'Land', 'Warehouse'],
    conditions: ['Brand new / New build', 'Good condition', 'Needs partial renovation', 'To renovate'],
    errors: {
      area: 'Please enter the area in m².',
      name: 'Please enter your name.',
      contact: 'We need an email or phone number to send you the result.',
      invalidData: 'Please check the property details (area and location).',
      generic: 'We couldn\'t calculate it right now. Please try again in a moment.',
    },
    result: {
      opSale: 'sale',
      opRent: 'monthly rent',
      opRentTemp: 'short-term rent',
      title: 'Your {{operation}} estimate',
      subtitle: 'Indicative price range based on market data.',
      perM2: '{{price}} per m²',
      perM2Month: '{{price}} per m² per month',
      noData: 'We don\'t have enough data for an automatic estimate. An advisor will contact you with a more accurate valuation.',
      officialTitle: 'Want an official signed appraisal?',
      officialText: 'An advisor will call you to arrange an appraisal with a certified surveyor (no obligation).',
      recalculate: 'Calculate another appraisal',
    },
  },
  mortgage: {
    title: 'Mortgage simulator',
    intro: 'A rough estimate to help you see whether this home fits your budget. The interest rate is editable; check with your bank before finalizing the numbers.',
    priceLabel: 'Property price',
    downPaymentLabel: 'Down payment / initial savings',
    downPaymentPercent: '{{percent}}% of the price',
    termLabel: 'Term (years)',
    yearsValue: '{{years}} years',
    annualRateLabel: 'Annual interest rate (%)',
    monthlyPayment: 'Monthly payment',
    totalPaid: 'Total to pay',
    totalInterest: 'Total interest',
    ctaWant: 'I want this mortgage',
    successMessage: 'Done! We received your request. An agent will contact you shortly.',
    contactTitle: 'Contact details',
    contactIntro: 'We\'ll call you to advise you on the mortgage for {{propertyTitle}}.',
    namePlaceholder: 'Full name',
    phonePlaceholder: 'Phone (+34 …)',
    emailPlaceholder: 'Email',
    contactHint: 'Provide at least one: phone or email.',
    messagePlaceholder: 'Message (optional)',
    back: 'Back',
    submitting: 'Sending…',
    submit: 'Send request',
    errorNameRequired: 'Enter your name and at least a phone number or email.',
    error400: 'Check your details: name and phone or email are required.',
    errorGeneric: 'Your request could not be sent. Please try again later.',
  },
};
